module.exports = __webpack_public_path__ + "img/exercise_closed-1.3b75f8e0.png";